<template>
  <div
    class="tw-bg-white tw-text-primary-grey-800 tw-w-full tw-flex tw-items-center tw-p-4 tw-border tw-border-primary-grey-100 tw-rounded-md tw-shadow-md tw-gap-4 tw-flex-col"
  >
    <t-empty>
      <template #title>
        {{ $t("subtext-threat-coach-not-analyzed") }}
      </template>
    </t-empty>
  </div>
</template>

<script setup lang="ts">
import TEmpty from "@/components/TEmpty";
</script>
